import { Observable, of } from 'rxjs';

export function getKnownIssues(): Observable<any[]> {
     return of([
          {
               id: 1,
               descriptionShown: false,
               isNew: true,
               name: "Tab Bar Ink Line",
               description: "When rotating the screen from portrait to landscape view (or vice versa) the selected tab blue ink line does not fully align with the selected tab.  Selecting the same or other tab corrects the alignment."
          },
          {
               id: 2,
               descriptionShown: false,
               isNew: true,
               name: "Aircraft Type and Nose Number",
               description: "Aircraft Type and Aircraft Nose number may be missing due to a lag in data retrieval from AA."
          },
          {
               id: 3,
               descriptionShown: false,
               isNew: true,
               name: "Analyze Totals",
               description: "Flight Totals data and charts may or may not equal to what is show on the user's HI*9."
          },
          {
               id: 4,
               descriptionShown: false,
               isNew: true,
               name: "Browser Usage",
               description: "When viewing Logbook app in a browser and selecting the browser back button instead of the breadcrumb links, the breadcrumb does not update to the actual navigated location."
          },
          {
               id: 5,
               descriptionShown: false,
               isNew: true,
               name: "Deadhead flights with no times",
               description: "Deadhead operated on airlines other than AA will not display actual flight times, currently the flight times will be displayed as 0:00 for the out and in times with a scheduled flight time as actual.  AA does not have access to these times."
          },
          {
               id: 6,
               descriptionShown: false,
               isNew: true,
               name: "Captian OE flight time",
               description: "Upgrade Captains conducting OE (operationaal experience) flights are inadverently being logged as Captain instead of First Officer.  This is a known issue and will be corrected in a future release."
          }

     ]);
}